var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-10 pb-5"},[_c('b-row',[_c('b-col',{staticClass:"pl-14 fs-16",attrs:{"cols":"12"}},[_c('b',[_vm._v(_vm._s(_vm.componentData.body))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }